import "./NavBar.css"

const NavBar = () => {
    return <>
        <div className="navBar-style">
            <h5 className="globalNavBar">Global Risks</h5>
        </div>
    </>
}

export default NavBar